<template>
  <div>
    <!-- <button> 运行 </button> -->
    <button @click="run_pro" class="run-button"> 运行 </button>
    <button @click="saveFile" id="save-btn" class="modern-btn"> 保存 </button>
    
    <select v-model="selectedFile" @change="editFile" :disabled="editingFile_bool" >
      <option value="" disabled>请选择程序</option>
      <option v-for="file in fileList" :key="file" :value="file" >{{ file }}</option>
    </select>
  </div>
  <hr>
  <codemirror
    v-model="code"
    placeholder="输入脚本代码..."
    :style="{ height: '100%' }"
    :autofocus="true"
    :indent-with-tab="true"
    :tab-size="2"
    :extensions="extensions"
    :hintOptions="hintOptions"
    @ready="handleReady"

  />
  <DufsFile />
</template>
    <!-- @change="log('change', $event)"
    @focus="log('focus', $event)"
    @blur="log('blur', $event)" -->
<script>
  import { defineComponent, ref, shallowRef } from 'vue'
  import { Codemirror } from 'vue-codemirror'
  import { keymap } from '@codemirror/view'
  import { acceptCompletion } from '@codemirror/autocomplete'
  
  import { rust } from '@codemirror/lang-rust'

  import { oneDark } from '@codemirror/theme-one-dark'
  
  import axios from 'axios';
  var base_url = localStorage.getItem('yun3d.3d_appurl_assets')?.replace(/"/g, '').trim();

  
  var appuserinfo = JSON.parse(localStorage.getItem('yun3d.3d_appuserinfo'));
  var username = encodeURIComponent(appuserinfo["username"]?.replace(/"/g, '').trim());

  var space_name = encodeURIComponent(localStorage.getItem('yun3d.3d_apppro_space_name')?.replace(/"/g, '').trim());
  var project_name = encodeURIComponent(localStorage.getItem('yun3d.3d_appproject_name')?.replace(/"/g, '').trim());
  const requestUrl = `${base_url}/project/${username}/${space_name}/${project_name}/assets/script/`;
  
  // const requestUrl = "http://192.168.10.122:5108/project/lbt888/lbt888%E7%A9%BA%E9%97%B4/SHIXUNTAI/assets/script/";
  // const requestUrl = "http://192.168.10.122:5108/project/lbt888/lbt888%E7%A9%BA%E9%97%B4/yu15/assets/script"

  // console.log("requestUrl",requestUrl);
  // 配置axios实例，基础URL指向你的DUFS服务
  const dufsAPI = axios.create({
    baseURL: requestUrl, // 根据你的DUFS实际地址修改
    // 如果DUFS设置了认证，可能需要在此配置headers
    // headers: { 'Authorization': 'Bearer your-token' }
    timeout: 2500,
  });
  const code = ref(``)

  /**
   * 等待直到从 localStorage 中成功获取并解析到有效数据
   * @param {string} key - 存储在 localStorage 中的键名
   * @param {number} interval - 检查间隔（毫秒）
   * @returns {Promise}
   */
  function waitForStorageValue(key, interval = 500) {
    return new Promise((resolve, reject) => {
      const checkInterval = setInterval(() => {
        const pathResStr = localStorage.getItem(key);
        if (pathResStr) {
          try {
            const parsedValue = JSON.parse(pathResStr);
            if (parsedValue && Object.keys(parsedValue).length > 0) {
              clearInterval(checkInterval);
              resolve(parsedValue); // Promise 成功解决，返回解析后的值
            }
          } catch (e) {
            clearInterval(checkInterval);
            reject(e); // Promise 被拒绝，返回错误
          }
        }
      }, interval);
    });
    }
  export default defineComponent({
    components: {
      Codemirror,
    },

    setup() {
      // const code = ref(`fn main() {\n    println!("Hello, world!");\n}`)

      const extensions = [
        rust(), 
     
        keymap.of([
            {
              key: 'Tab',
              run: acceptCompletion, // 接受自动补全
            },
              {
            key: "Ctrl-s", // 注意：键名使用小写字母
              run: () => {
                const button = document.getElementById('save-btn');
                button.click();
                return true; // 返回true表示已处理此快捷键
              }
            }
          ]), 
        oneDark
      ]

      // Codemirror EditorView instance ref
      const view = shallowRef()
      const handleReady = (payload) => {
        view.value = payload.view
      }

      return {
        code,
        extensions,

        handleReady,
                // 配置提示选项
        hintOptions: {
          completeSingle: false // 当只有一项匹配时，不自动补全
        },
        log: console.log
      }
    },
    name: 'FileManager',
    data() {
      return {
        selectedFile: '',
        fileList: [],
        editingFile: null,
        editingFile_bool: false,
        fileContent: ''
      };
    },
    methods: {

      // 获取文件列表
      async listFiles() {
        try {
          // 注意：DUFS的API返回格式可能是JSON，具体需参考其文档
          // const response = await dufsAPI.get('/?json'); // 假设以JSON格式列出文件
          // const pathResStr = localStorage.getItem('yun3d.3d_appscript');
          // this.fileList = JSON.parse(pathResStr);
          this.fileList = await waitForStorageValue('yun3d.3d_appscript');
          // console.log(this.fileList);
        } catch (error) {
          // console.error('获取文件列表失败:', error);
        }
      },

      // 编辑文件：先获取内容，然后放入编辑器
      async editFile() {
        
        try {
          this.editingFile_bool = true;
          // const getAPI = axios.create({
          //     baseURL: requestUrl, // 根据你的DUFS实际地址修改
          //     // 如果DUFS设置了认证，可能需要在此配置headers
          //     // headers: { 'Authorization': 'Bearer your-token' }
          //     timeout: 2000,
          // });
          code.value = ""
          const response = await dufsAPI.get(`/${this.selectedFile}/${this.selectedFile}.rhai?v=${Date.now()}`,
              {headers: { 'Content-Type': 'text/plain' }}
          );
          code.value = response.data;
          this.editingFile_bool = false;
        } catch (error) {
          // console.error('获取文件内容失败:', error);
          this.editingFile_bool = false;
          alert('脚本获取失败。');
        }
      },

      // 保存文件：将编辑后的内容写回DUFS
      async saveFile() {
        this.editingFile_bool = true;
        
        try {
          if (code.value.length === 0) {
            this.editingFile_bool = false;
            alert('文件为空保存失败');
            return
          }
          // 使用PUT请求上传文件内容，注意DUFS API的具体要求
          await dufsAPI.put(`/${this.selectedFile}/${this.selectedFile}.rhai`, code.value, {
            headers: { 'Content-Type': 'text/plain' } // 根据实际文件类型设置Content-Type
          });
          this.editingFile_bool = false;
          setTimeout(() => {
            this.cancelEdit();
            this.listFiles();
          }, 1000);
          // this.listFiles(); // 刷新文件列表
    
        } catch (error) {
          // console.error('保存文件失败:', error);
          this.editingFile_bool = false;
          alert('文件保存失败。');
        }
      },
      async run_pro() {
        await this.saveFile().then(() => {
          localStorage.setItem('yun3d.3d_apprun_name', '"'+this.selectedFile+'"');
        });
      },
      // 删除文件
      async deleteFile(filename) {
        if (!confirm(`确定要删除文件 "${filename}" 吗？`)) return;
        
        try {
          await dufsAPI.delete(`/${filename}`);
          alert('文件删除成功！');
          // this.listFiles(); // 刷新文件列表
          setTimeout(() => {
            // this.cancelEdit();
            this.listFiles();
          }, 500);
        } catch (error) {
          alert('文件删除失败。');
        }
      },

      // 取消编辑
      cancelEdit() {
        this.editingFile = null;
        this.fileContent = '';
      },

      async startFileSync() {
        this.syncTimer = setInterval(async () => {
          try {
            await this.syncFiles();
          } catch (error) {
            // console.error('文件同步失败:', error);
          }
        }, 500);
      },
      
      stopFileSync() {
        if (this.syncTimer) {
          clearInterval(this.syncTimer);
          this.syncTimer = null;
        }
      },
      getExtension(filePath) {
        const match = filePath.match(/\.([^.]+)$/);
        return match ? match[1].toLowerCase() : '';
      },
      async syncFiles() {
        const pathResStr = localStorage.getItem('yun3d.3d_apppath_res');
        if (!pathResStr || pathResStr === '[]') {
          return; // 没有需要同步的文件
        }
        
        let pathRes;
        try {
          pathRes = JSON.parse(pathResStr);
        } catch (error) {
          // console.error('解析path_res失败:', error);
          return;
        }
        
        // console.log("path_res", pathRes);
        
        // 并行处理所有文件
        const syncPromises = pathRes.map(async (element) => {
          try {
            const path = element.replace(/\\/g, '/').trim();
            // console.log("正在同步文件:", path);

            // const host = location().host;
            // const protocol = location().protocol;
            // 创建axios实例获取源文件
            const sourceClient = axios.create({
              baseURL: "/assets/",
              timeout: 10000, // 10秒超时
            });
           
            // 获取源文件数据
            const response = await sourceClient.get(
              path,
              {
                responseType: 'arraybuffer'  // 处理二进制文件
              }
            );
            const fileData = response.data;
            // console.log("文件同步:", path);
            // console.log("sourceClient:", sourceClient.headers);
            // 创建axios实例上传文件
            const targetClient = axios.create({
              baseURL: `${base_url}/project/${username}/${space_name}/${project_name}/assets/`,
              timeout: 15000, // 15秒超时
            });

            const mimeTypes = {
              'glb': 'model/gltf-binary',
              'gltf': 'model/gltf+json',
              'png': 'image/png',
              'jpg': 'image/jpeg',
              'jpeg': 'image/jpeg',
              'gif': 'image/gif',
              'json': 'application/json',
              'xml': 'application/xml',
              'urdf': 'application/xml',
              'rhai': 'text/plain',
              'txt': 'text/plain',
              'md': 'text/markdown'
            };
            
            const ext = this.getExtension(path);
            const mimeType = mimeTypes[ext] || 'application/octet-stream';
            
            // 上传文件
            await targetClient.put(path, fileData,{
              headers: {
                'Content-Type': mimeType,
              },
            });
            
            // console.log("文件同步成功:", path);
            return { success: true, path };
          } catch (error) {
            // console.error(`同步文件失败 ${element}:`, error);
            return { success: false, path: element, error };
          }
        });
        
        // 等待所有文件同步完成
        const results = await Promise.allSettled(syncPromises);
        
        // 检查是否有失败的情况
        const failedSyncs = results
          .filter(result => result.status === 'fulfilled' && !result.value.success)
          .map(result => result.value.path);
        
        if (failedSyncs.length === 0) {
          // 所有文件同步成功，清空列表
          localStorage.setItem('yun3d.3d_apppath_res', "[]");
          // console.log("所有文件同步完成");
        } else {
          // 有失败的文件，保留在列表中
          // console.warn("部分文件同步失败，将重试:", failedSyncs);
          // 可以在这里添加重试逻辑或错误上报
        }
      },

    },
        // watch 监听
    watch(){
      () => {
 




      }

    },
    mounted() {
      localStorage.setItem('yun3d.3d_appscript','[]');
      this.editingFile_bool = true;
      setTimeout(() => {
        this.listFiles();
        this.editingFile_bool = false;
      }, 1500);
      // 启动定时器
      this.startFileSync();
      

          // 实时更新示例
      // this.timer = setInterval(async () => {
      //   var path_res = JSON.parse(localStorage.getItem('yun3d.3d_apppath_res'));
      //   console.log("path_res",path_res);

      //   path_res.forEach(element => {
      //     var path = element.replace(/\\/g, '/').trim();
      //     console.log("path",path);
      //     var get = axios.create({
      //       baseURL: path, // 根据你的DUFS实际地址修改
      //       // 如果DUFS设置了认证，可能需要在此配置headers
      //       // headers: { 'Authorization': 'Bearer your-token' }
      //     });
      //     get.get().then((response) => {
            
      //       var put = axios.create({
      //         baseURL: `${base_url}/project/${username}/${space_name}/${project_name}/assets/`, // 根据你的DUFS实际地址修改
      //         // 如果DUFS设置了认证，可能需要在此配置headers
      //         // headers: { 'Authorization': 'Bearer your-token' }
      //       });
      //       put.put(path, response.data);
      //       console.log(response.data);
      //     });

      //   });
      //   localStorage.setItem('yun3d.3d_apppath_res', "[]");
        
      // }, 500)
    },
    beforeUnmount() { // 或者 beforeDestroy
      this.stopFileSync();
    },
  })
</script>

<style scoped>
.modern-btn {
  margin: 0 5px;
  padding: 4px 16px;
  background: linear-gradient(135deg, #4f6df5 0%, #3a56e5 100%);
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(79, 109, 245, 0.3);
  position: relative;
  overflow: hidden;
}

.modern-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(79, 109, 245, 0.4);
  background: linear-gradient(135deg, #5a75f7 0%, rgb(35, 63, 223) 100%);
}

.modern-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(79, 109, 245, 0.4);
}

.run-button {
  /* 基础样式 */
  background: linear-gradient(135deg, rgb(84, 238, 84) 0%, rgb(66, 221, 87) 100%); /* 科技感蓝色渐变 */
  color: rgb(58, 58, 58);
  border: none;
  padding: 4px 16px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px 0 rgba(79, 172, 254, 0.3); /* 与背景色呼应的阴影 */
  outline: none;
  
}

/* 悬停效果 */
.run-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px 0 rgba(125, 189, 50, 0.4);
  background: linear-gradient(135deg, #8bdd88 0%, #99d388 100%);
}

/* 点击效果 */
.run-button:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 2px 10px 0 rgba(79, 172, 254, 0.3);
}

</style>
